// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import ProImage from 'images/pro-icon-for-search.svg'

export default function ProBadge () {
  return (
    <div
      data-tooltip
      className='pro-supplier-indicator body-x-small'
      tabIndex='2'
      title='This supplier upgraded to a pro profile, which allows them to include additional information on their Procurated page.'
    >
      <img src={ProImage} alt='Pro Supplier' />
      Pro
    </div>
  )
}
